let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("b3fEm")).then(() => parcelRequire('gx6lL'));